document.addEventListener("DOMContentLoaded", function () {
  const sizeRadios = document.querySelectorAll(
    '.variant-picker-custom input[type="radio"]'
  );
  const addToCartBtn = document.querySelector(".product-form__submit");
  const shopifyPayBtn = document.querySelector("shopify-accelerated-checkout");
  const buttonsWrapper = document.querySelector(".product-form__buttons");

  if (!sizeRadios.length || !buttonsWrapper) return;

  // Page load pe size unselect
  sizeRadios.forEach((radio) => (radio.checked = false));

  // Real buttons hide (CSS already did, this is extra-safe)
  if (addToCartBtn) addToCartBtn.style.display = "none";
  if (shopifyPayBtn) shopifyPayBtn.style.display = "none";

  // Select size placeholder button
  const placeholderBtn = document.createElement("button");
  placeholderBtn.textContent = "Select a size";
  placeholderBtn.disabled = true;
  placeholderBtn.className =
    "button button--full-width button--secondary select-size-btn";

  buttonsWrapper.prepend(placeholderBtn);

  // Size select hone par real buttons show
  sizeRadios.forEach((radio) => {
    radio.addEventListener("change", () => {
      if (radio.checked) {
        placeholderBtn.style.display = "none";

        // 🔴 YAHI MAIN LINE HAI
        buttonsWrapper.style.display = "block";

        if (addToCartBtn) addToCartBtn.style.display = "block";
        if (shopifyPayBtn) shopifyPayBtn.style.display = "block";
      }
    });
  });
});



document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth > 767) return; // mobile only

  const sizeRadios = document.querySelectorAll(
    '.variant-picker-custom input[type="radio"]'
  );
  const addToCartBtn = document.querySelector(".product-form__submit");
  const sizeSection = document.querySelector(".variant-picker-custom");

  if (!sizeRadios.length || !addToCartBtn || !sizeSection) return;

  /* ---------------- Sticky bar create ---------------- */
  const stickyBar = document.createElement("div");
  stickyBar.className = "mobile-sticky-bar";

  const stickyBtn = document.createElement("button");
  stickyBtn.className = "button button--full-width button--secondary";
  stickyBtn.textContent = "Select a size";

  stickyBar.appendChild(stickyBtn);
  document.body.appendChild(stickyBar);

  // 🔴 Page load → hidden
  stickyBar.classList.remove("show");

  /* ---------------- Helpers ---------------- */
  const isSizeSelected = () =>
    [...sizeRadios].some((radio) => radio.checked);

  const scrollToSize = () => {
    sizeSection.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  };

  /* ---------------- Button click ---------------- */
  stickyBtn.addEventListener("click", function () {
    if (!isSizeSelected()) {
      scrollToSize();
    } else {
      addToCartBtn.click();
    }
  });

  /* ---------------- Size select change ---------------- */
  sizeRadios.forEach((radio) => {
    radio.addEventListener("change", () => {
      if (radio.checked) {
        stickyBtn.textContent = "Add to cart";
        stickyBtn.classList.remove("button--secondary");
        stickyBtn.classList.add("button--primary");
        stickyBar.classList.add("show"); // size select → bar permanently show
      }
    });
  });

  /* ---------------- Scroll logic ---------------- */
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        // size select nahi hua → scroll pe show/hide
        if (!isSizeSelected()) {
          if (entry.boundingClientRect.top < 0) {
            stickyBar.classList.add("show");
          } else {
            stickyBar.classList.remove("show");
          }
        } 
        // else → size selected → sticky bar permanently show (handled above)
      });
    },
    {
      root: null,
      threshold: 0,
    }
  );

  observer.observe(sizeSection);
});




// document.addEventListener("DOMContentLoaded", function () {
//   const sizeRadios = document.querySelectorAll(
//     '.variant-picker-custom input[type="radio"]'
//   );
//   const addToCartBtn = document.querySelector(".product-form__submit");
//   const shopifyPayBtn = document.querySelector("shopify-accelerated-checkout");
//   const buttonsWrapper = document.querySelector(".product-form__buttons");

//   if (!sizeRadios.length || !buttonsWrapper) return;

//   // Page load pe size unselect
//   sizeRadios.forEach((radio) => (radio.checked = false));

//   // Real buttons hide
//   if (addToCartBtn) addToCartBtn.style.display = "none";
//   if (shopifyPayBtn) shopifyPayBtn.style.display = "none";

//   // Select size placeholder button
//   const placeholderBtn = document.createElement("button");
//   placeholderBtn.textContent = "Select a size";
//   placeholderBtn.disabled = true;
//   placeholderBtn.className =
//     "button button--full-width button--secondary select-size-btn";

//   buttonsWrapper.prepend(placeholderBtn);

//   // Size select hone par real buttons show
//   sizeRadios.forEach((radio) => {
//     radio.addEventListener("change", () => {
//       if (radio.checked) {
//         placeholderBtn.style.display = "none";
//         if (addToCartBtn) addToCartBtn.style.display = "block";
//         if (shopifyPayBtn) shopifyPayBtn.style.display = "block";
//       }
//     });
//   });
// });











// document.addEventListener("DOMContentLoaded", function () {
//   if (window.innerWidth > 767) return; // mobile only

//   const sizeRadios = document.querySelectorAll(
//     '.variant-picker-custom input[type="radio"]'
//   );
//   const addToCartBtn = document.querySelector(".product-form__submit");
//   const sizeSection = document.querySelector(".variant-picker-custom");

//   if (!sizeRadios.length || !addToCartBtn || !sizeSection) return;

//   // Create sticky bar
//   const stickyBar = document.createElement("div");
//   stickyBar.className = "mobile-sticky-bar";

//   const stickyBtn = document.createElement("button");
//   stickyBtn.className = "button button--full-width button--secondary";
//   stickyBtn.textContent = "Select a size";

//   stickyBar.appendChild(stickyBtn);
//   document.body.appendChild(stickyBar);

//   // Helper: check if size selected
//   const isSizeSelected = () =>
//     [...sizeRadios].some((radio) => radio.checked);

//   // Scroll to size section
//   const scrollToSize = () => {
//     sizeSection.scrollIntoView({
//       behavior: "smooth",
//       block: "center",
//     });
//   };

//   // Button click behavior
//   stickyBtn.addEventListener("click", function () {
//     if (!isSizeSelected()) {
//       scrollToSize();
//     } else {
//       addToCartBtn.click();
//     }
//   });

//   // On size select → update button
//   sizeRadios.forEach((radio) => {
//     radio.addEventListener("change", () => {
//       if (radio.checked) {
//         stickyBtn.textContent = "Add to cart";
//         stickyBtn.classList.remove("button--secondary");
//         stickyBtn.classList.add("button--primary");
//       }
//     });
//   });
// });
jQuery(document).ready(function ($) {
  $('.open-pay-popup').magnificPopup({
    type: 'inline',
    midClick: true
  });
});